namespace RedBullMOBILE360.Utilities {
    @Serenity.Decorators.registerClass()
    export class ReAuthExcelImportDialog extends Serenity.PropertyDialog<any, any>  {
        private form: ReAuthExcelImportForm;

        constructor() {
            super();

            this.form = new ReAuthExcelImportForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Import Numbers";
        }

        protected getDialogButtons() {
            let buttons = [];
            buttons.push({
                text: 'Send',
                cssClass: 'export-xlsx-button',
                click: () => {
                    if (!this.validateBeforeSave())
                        return;

                    if (this.form.FileName.value == null ||
                        Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                        Q.notifyError("Please select a file!");
                        return;
                    }

                    ReAuthenticateNumbersService.ExcelImport({
                        FileName: this.form.FileName.value.Filename
                    }, (response) => {
                        let messageParts = new Array<string>();
                        messageParts.push("Sent successfully: " + (response.Inserted || 0));
                        if (response.Updated > 0)
                            messageParts.push("Failed: " + response.Updated);
                        if (response.ErrorList && response.ErrorList.length > 0) {
                            messageParts.push("<span style='color:red;'>Failed numbers:</span>");
                            response.ErrorList.forEach((val) => messageParts.push(val));
                        }
                        Q.information(messageParts.join("<br/>"), () => { }, {
                            htmlEncode: false
                        });
                        this.dialogClose();
                    });
                },
            });
            buttons.push(
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            );
            return buttons;
        }


    }
}